export default __webpack_public_path__ + "static/media/foodieUiMob.70239c6f.png";